import { useToast } from 'primevue/usetoast';
import type { ToastMessageOptions } from 'primevue/toast';
import { usePreconToastsOptions } from './usePreconToastsOptions';
import {
    connectMessage,
    createMessage,
    deleteMessage,
    errorMessage,
    updateMessage,
} from '../helpers/toastMessageBuilders';
import type { actionMessageOptions, errorMessageOptions } from '../options';

export function usePreconToasts() {
    // Inject the global options.
    const options = usePreconToastsOptions();
    const defaultMessage = {
        closable: options.closable,
        life: options.life,
    } as ToastMessageOptions;

    // Inject the toast service
    const toast = useToast();

    function showMessage(
        messageOptions: actionMessageOptions | errorMessageOptions
    ) {
        let message: ToastMessageOptions;
        switch (messageOptions.messageType) {
            case 'create':
                message = createMessage(
                    defaultMessage,
                    messageOptions?.entityTypename,
                    messageOptions?.entityName
                );
                break;
            case 'update':
                message = updateMessage(
                    defaultMessage,
                    messageOptions?.entityTypename,
                    messageOptions?.entityName
                );
                break;
            case 'delete':
                message = deleteMessage(
                    defaultMessage,
                    messageOptions?.entityTypename,
                    messageOptions?.entityName
                );
                break;
            case 'connect':
                message = connectMessage(
                    defaultMessage,
                    messageOptions?.entityName
                );
                break;
            case 'error':
                message = errorMessage(
                    defaultMessage,
                    messageOptions?.actionType,
                    messageOptions?.error
                );
                break;
        }
        toast.add(message);
    }

    return { showMessage };
}
